module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-48x48.063cb1e029666714e4132bb57af3e41c.png";